<script lang="ts">
  import { Button } from "sveltestrap";
  import { Send, cancel, href } from "../../../../utils/Constant/Constant";

</script>
<div class="action-wrapper">
    <ul class="actions">
        <li>
            <Button color="secondary" href={href}>
                <i class="fa fa-paper-plane me-2"></i>{Send} 
            </Button>
        </li>
        <li>
            <Button color="danger" href={href}>
                <i class="fa fa-times me-2"></i>{cancel}
            </Button>
        </li>
    </ul>
</div>